import { Component, ElementRef, OnInit, ViewContainerRef, Output, EventEmitter } from '@angular/core';
import { Onboarding, Status, LeadSource } from '../../../models/onboarding';
import { ApiService } from '../../../services/api.service';
import { ModalDialogService } from 'ngx-modal-dialog';
import { AlgConditionModalComponent } from '../../dialogs/alg-condition-modal/alg-condition-modal.component';
import { AlgConditionPrivacyModalComponent } from '../../dialogs/alg-condition-privacy-modal/alg-condition-privacy-modal.component';
import { conditionTextList, paymentConditionTypeToReplace } from '../../../models/contitions';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Product, VulnerabilityType, Source } from '../../../models/product';
import { Cooperative } from '../../../models/cooperatives';
import { UtilsService } from '../../../services/utils.service';
import { AlgGtmService } from '../../../services/alg-gtm.service';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { debounceTime, take } from 'rxjs/operators';
import { checkUserAgeByCf, isPast2024, isUser75OrOlder } from '../../../utils/cf';

@Component({
  selector: 'alg-complete',
  templateUrl: './alg-complete.component.html',
  styleUrls: ['./alg-complete.component.scss'],
})
export class AlgCompleteComponent implements OnInit {
  @Output() statusBack = new EventEmitter<string>();

  public currentOnboarding: Onboarding = {} as Onboarding;
  public currentProduct: Product = {} as Product;
  public cooperatives: Cooperative[];
  public greenEnergy = false;
  public summaryForm: FormGroup;
  public code_1: number = null;
  public code_2: number = null;
  public code_3: number = null;
  public code_4: number = null;

  public labelCondition: string;
  public optionAccept: string;
  public promoText: string;
  public userInfoForm: FormGroup;
  public otpStep = 1;
  public code_status_class = 'input-field';
  public error_message_label = null;
  public new_sms_sent = false;
  public otp_process_ok = false;
  public remember = false;
  public oldPhone = null;
  public enableOtpVerification = false;
  public enableOtpVerificationButton = false;
  public checkboxClass = false;
  public checkboxClass2 = false;
  public checkboxClassButton = false;
  public isProductPlacet: boolean;
  public isCoopAlleanza: boolean;
  public isUser75YearsOld: boolean;
  public fiscalCode: string;
  public isPast2024: boolean;
  public isUnicaCoop: boolean;
  public summaryCoopAlleanza: string;
  public ruleBookUnicaCoop: string;
  public extraPoints: string;

  public enabledAcceptances = {
    economic: false,
    supplies: false,
    cadastral: false,
    clause: false,
    consents: false,
  };

  public conditions = [
    {
      label: 'Accetto e prendo visione delle <strong>Condizioni Tecnico economiche</strong>',
      slug: 'economicCondition',
    },
    {
      label: 'Accetto e prendo visione delle <strong>Condizioni generali di fornitura</strong>',
      slug: 'suppliesCondition',
    },
    {
      label: `Accetto e prendo visione dell'<strong>informativa sui dati catastali.</strong>`,
      slug: 'cadastralCondition',
    },
    // tslint:disable-next-line:max-line-length
    {
      label: `Accetto e prendo visione dell'<strong>Accettazione espressa di clausole </strong> ai sensi e per gli effetti di cui agli art.1341 e 1342 cod. civ.`,
      slug: 'clausole',
    },
    {
      label: `Accetto prendo visione dell'<strong>informativa contrattuale e consensi.</strong>`,
      slug: 'constentsCondition',
    },
  ];

  // public summarySheet = "https://s3.eu-central-1.amazonaws.com/documenti.lucegasecoop.it/vulnerable/Scheda_Sintetica_Cliente_Vulnerabili_Gas.pdf"

  public goAhead = false;
  public otpChallenge = false;

  public checkBox1 = false;
  public checkBox2 = false;

  public placet = null;
  public supplyType = null;
  public numberShort = false;
  public noNumber = false;
  public phoneNumberPre = false;
  private codeTemp = '';
  constructor(
    private api: ApiService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    private gtm: AlgGtmService,
    private el: ElementRef
  ) {
    this.api.isUser75YearsOld$.subscribe((value) => {
      this.isUser75YearsOld = value;
    });
    this.api.userFiscalCode$.subscribe((value) => {
      this.fiscalCode = value;
    });
  }

  ngOnInit() {
    this.api.currentOnboarding
      .combineLatest(this.api.currentProduct, this.api.promotions, this.api.currentLightGreen, this.api.cooperatives)
      .subscribe(([onboarding, product, promotions, lightGreen, cooperatives]) => {
        this.choosePrivacyText(product);
        this.currentOnboarding = onboarding;
        this.currentProduct = product;
        this.cooperatives = cooperatives;
        if (this.currentProduct && !!this.currentProduct.family && this.currentProduct.family.name === 'Placet') {
          this.isProductPlacet = true;
        }
        this.greenEnergy = lightGreen;
        this.cooperatives = cooperatives;

        const currentPromo = promotions.find((p) => p.code === this.currentOnboarding.promoCode);
        if (currentPromo) {
          this.promoText = product.type === 'Luce & Gas' ? currentPromo.descriptionBi : currentPromo.descriptionMono;
        }

        if (this.currentOnboarding.phone) {
          this.phoneNumberPre = true;
        }

        if (this.currentOnboarding.socioType) {
          this.cooperatives.map((v, i) => {
            if (v._id === this.currentOnboarding.socioType) {
              if (v.name === 'Coop Alleanza 3.0') {
                this.isCoopAlleanza = true;
              } else {
                this.isCoopAlleanza = false;
              }
            }
          });
        }

        if (this.currentProduct.family && this.currentProduct.family.productSource == Source.accendiUnicaCoop) {
          this.isUnicaCoop = true;
        }

        if (this.cooperatives[1]) {
          this.summaryCoopAlleanza = this.cooperatives[1].summaryCoopAlleanza;
          this.ruleBookUnicaCoop = this.cooperatives[1].ruleBookUnicaCoop;
          this.extraPoints = this.cooperatives[1].pointsFor12;
        }
      });
    this.summaryForm = new FormGroup({
      phone: new FormControl(this.currentOnboarding.phone, {
        validators: [Validators.required, Validators.minLength(9), Validators.maxLength(11)],
      }),
      otpFourDigit: new FormControl(this.currentOnboarding.otp_four_digit, {
        validators: [Validators.required, Validators.minLength(4), Validators.maxLength(4)],
      }),
      firstCondition: new FormControl('', {
        validators: [Validators.requiredTrue],
      }),
      secondCondition: new FormControl('', {
        validators: [Validators.requiredTrue],
      }),
    });

    this.summaryForm.valueChanges.subscribe((data) => {
      Object.keys(data);
    });

    if (this.currentOnboarding.otp_verified) {
      this.otpStep = 3;
      this.otpChallenge = true;
    }
    if (this.fiscalCode.length > 0) {
      this.isUser75YearsOld = isUser75OrOlder(checkUserAgeByCf(this.fiscalCode));
    } else {
      this.isUser75YearsOld = isUser75OrOlder(checkUserAgeByCf(this.currentOnboarding.cf));
    }
    this.isPast2024 = isPast2024();
  }
  private choosePrivacyText(product) {
    this.placet = product.source === 'ALG' ? false : true;
    this.supplyType = product.type === 'Luce & Gas' ? 'DUAL' : product.type === 'Luce' ? 'LUCE' : 'GAS';
  }

  openModal(modalContent) {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: modalContent.title,
      childComponent: AlgConditionModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: 'modal-title modal-title-underline modal-title-padding-r',
      },
      data: {
        description: modalContent.description,
        title: modalContent.title,
      },
    });
  }

  openPrivacyModal(modalContent) {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: modalContent.title,
      childComponent: AlgConditionPrivacyModalComponent,
      settings: {
        modalClass: 'modal fade ngx-modal modal-privacy',
        bodyClass: 'modalClassBody',
        modalDialogClass: 'modalDialogClass',
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: 'modal-title modal-title-underline modal-title-padding-r',
      },
      data: {
        description: modalContent.description,
        title: modalContent.title,
        placet: modalContent.placet,
        supplyType: modalContent.supplyType,
        modalN: modalContent.modalN,
        productFamily: modalContent.productFamily,
      },
    });
  }

  downloadCTE() {
    const options = {
      product: this.currentOnboarding.product.name || this.currentProduct.name,
      promo: !this.currentOnboarding.promoCode || this.currentOnboarding.promoCode.length === 0 ? null : this.currentOnboarding.promoCode,
      offerType: 'ALG',
      priceTypology: this.currentOnboarding.product.priceType || this.currentProduct.priceType,
      placet: this.currentOnboarding.product.source || this.currentProduct.source,
      commodity: this.currentOnboarding.product.type || this.currentProduct.type,
      duration:
        this.currentProduct.name.includes('CASA AGILE') || this.currentProduct.name.includes('CASA AGILE ECOLOGICA')
          ? '12'
          : this.currentProduct.duration.replace(' Mesi', '') || this.currentOnboarding.product.duration.replace(' Mesi', ''),
      renew: null,
    };
    return this.api
      .getCTE(options)
      .toPromise()
      .then((data) => this.downloadPdf(data))
      .catch((err) => {
        alert('Error');
      });
  }

  downloadVulnerabilitySummarySheet() {
    return this.api
      .getVulnerabilitySummarySheet()
      .toPromise()
      .then((data) => this.downloadPdf(data))
      .catch((err) => {
        alert('Error');
      });
  }

  downloadCGF() {
    const options = {
      unipol: false,
      placet: this.currentOnboarding.product.source || this.currentProduct.source,
      commodity: this.currentOnboarding.product.type || this.currentProduct.type,
    };
    return this.api
      .getCGF(options)
      .toPromise()
      .then((data) => this.downloadPdf(data))
      .catch((err) => {
        alert('Error');
      });
  }

  downloadPdf(data) {
    let newBlob = new Blob([data], { type: 'application/pdf' });
    let url = window.URL.createObjectURL(newBlob);
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed === 'undefined') {
      alert('Please disable your Pop-up blocker and try again.');
    }
  }

  openPDF(index) {
    if (index === 0) {
      this.enabledAcceptances.economic = true;
      this.currentOnboarding.economicCondition = true;
      this.downloadCTE();
    } else {
      this.enabledAcceptances.supplies = true;
      this.currentOnboarding.suppliesCondition = true;
      this.downloadCGF();
    }
    return true;
  }

  readCondition(type, num = 0) {
    let modalContent;
    let suffix = '';
    if (type.startsWith('OnbClauseCondition') && !this.isProductPlacet && this.isUser75YearsOld && this.supplyType !== 'LUCE') {
      suffix = '-VULNERABILI';
    }
    switch (type) {
      case 'attivazioneVeloce':
        modalContent = this.getAttivazioneVeloceModalContent(type);
        console.log('type', type);
        console.log('modalContent', modalContent);
        this.openModal(modalContent || {});
        break;
      default:
        if (paymentConditionTypeToReplace.includes(type) && this.isUser75YearsOld && this.supplyType !== 'LUCE') {
          suffix = '-VULNERABILI';
        }
        modalContent = conditionTextList.consents[type + suffix] || conditionTextList.clause['*'];
        modalContent.placet = this.placet;
        modalContent.supplyType = this.supplyType;
        modalContent.modalN = num;
        modalContent.productFamily = this.currentProduct.family.productSource;
        this.openPrivacyModal(modalContent || {});
        break;
    }
    return;
  }

  private getAttivazioneVeloceModalContent(type: string) {
    let suffix = '';
    if (this.isProductPlacet) {
      suffix = 'PLACET';
    }
    if (this.isUser75YearsOld && this.supplyType !== 'LUCE') {
      suffix = 'VULNERABILI';
    }
    console.log('type', type);
    console.log('suffix', suffix);
    console.log('conditionTextList.helper[type + suffix]', conditionTextList.helper[type + suffix]);
    return conditionTextList.helper[type + suffix] || conditionTextList.clause['*'];
  }

  changeCheckbox(event, checkbox) {
    switch (checkbox) {
      case 'economic':
        if (!this.enabledAcceptances.economic) {
          // window.open(this.currentProduct.technicalCondition);
          this.downloadCTE();
        }
        this.enabledAcceptances.economic = true;
        break;
      case 'supplies':
        if (!this.enabledAcceptances.supplies) {
          // window.open(this.currentProduct.generalCondition);
          this.downloadCGF();
        }
        this.enabledAcceptances.supplies = true;
        break;
      case 'cadastral':
      case 'clause':
      case 'consents':
        if (!this.enabledAcceptances[checkbox]) {
          this.readCondition(checkbox);
        }
        this.enabledAcceptances[checkbox] = true;
        break;
    }
    this.allowFinish();
  }

  allowFinish() {
    this.goAhead =
      this.currentOnboarding.economicCondition === true &&
      this.currentOnboarding.suppliesCondition === true &&
      this.currentOnboarding.clauseCondition === true &&
      this.currentOnboarding.cadastralCondition === true &&
      this.currentOnboarding.consentsCondition === true;
  }

  nextStep() {
    this.markFormGroupTouched(this.summaryForm);
    const invalidControl = this.el.nativeElement.querySelector('form .ng-invalid');
    if (invalidControl) {
      return this.scrollOnInvalidElement(invalidControl);
    }
    if (this.goAhead && this.otpChallenge) {
      this.currentOnboarding.leadSource = LeadSource.complete;
      if (this.isUser75YearsOld && this.supplyType !== 'LUCE') {
        this.currentOnboarding.vulnerabilityType = VulnerabilityType.anagraficAge;
      }
      delete this.currentOnboarding.otp_four_digit;
      this.api.nextStep(this.currentOnboarding, Status.summary);
    }
  }

  fake_p_reject(data) {
    return new Promise((resolve, reject) => reject(data));
  }
  fake_p_resolve() {
    return new Promise((resolve, reject) => resolve(true));
  }

  sendMeOtpCode(reSend: boolean = false) {
    if (!this.checkBox1 || !this.checkBox2) {
      this.markFormGroupTouched(this.summaryForm);
      const invalidControl = this.el.nativeElement.querySelector('form .ng-invalid');
      if (invalidControl) {
        return this.scrollOnInvalidElement(invalidControl);
      }
    }

    if (!this.goAhead) {
      return;
    }

    this.gtm.submitOnbEvent('otp', reSend ? 'invia di nuovo' : 'invia codice');

    this.error_message_label = false;
    this.checkboxClassButton = false;
    this.currentOnboarding.otp_sms_sent++;
    if (!this.currentOnboarding.phone || this.currentOnboarding.phone.toString().length > 10 || this.currentOnboarding.phone.toString().length < 9)
      return console.log('Number not found');
    return this.api.sendMeOtpCode(this.currentOnboarding.phone, this.currentOnboarding._id, false).subscribe((response) => {
      if (response.status === 400) {
        this.new_sms_sent = false;
        this.error_message_label = 'Errore generico, contattare il call center.';
        return;
      } else if (response.status && response.statusText && response.status === 429 && response.statusText == 'Too Many Requests') {
        this.new_sms_sent = false;
        this.error_message_label = 'Potrai richiedere un nuovo codice tra: 1 minuto';
        return;
      } else {
        this.otpStep = 2;
        this.enableOtpVerification = true;
      }
      return;
    });
  }

  async checkOtpCodeLogic() {
    if (this.otpChallenge) {
      return;
    }
    this.new_sms_sent = false;
    this.code_status_class = 'input-field';
    this.error_message_label = null;
    return this.api.checkOtpCode(this.currentOnboarding.otp_four_digit, this.currentOnboarding._id, false).toPromise();
  }

  async checkOtpCode() {
    if (this.otpChallenge) {
      return;
    }
    await this.checkOtpCodeLogic()
      .then((response) => {
        this.currentOnboarding.otp_date = new Date().toISOString();
        this.currentOnboarding.otp_phone = this.currentOnboarding.phone;
        this.currentOnboarding.otp_verified = true;
        this.otp_process_ok = true;
        this.code_status_class = 'input-success';

        // this.utils.abilityOverflow();
        this.otpStep = 3;
        this.gtm.submitOnbEvent('otp', 'codice confermato');
        return (this.otpChallenge = true);
      })
      .catch((err) => {
        this.gtm.submitOnbEvent('otp', 'codice errato');
        this.currentOnboarding.otp_four_digit = null;
        if (err === 'JUSTNUMBER') {
          this.error_message_label = 'Il codice è composto solo da numeri';
          this.code_status_class = 'input-error';
        } else if (err === 'CODEREUIRED') {
          this.error_message_label = 'Il codice è richiesto';
          this.code_status_class = 'input-error';
        } else {
          this.code_status_class = 'input-error';
          this.error_message_label = 'Codice errato, riprovare';
          this.utils.abilityOverflow();
        }
        return;
      });
  }

  checkNumberPhone(value) {
    if (value.length < 9) {
      this.numberShort = true;
      this.noNumber = false;
    }
    if (value.length === 0 || value.length == null || value.length === undefined) {
      this.noNumber = true;
      this.numberShort = false;
    }
    if (value.length >= 9) {
      this.noNumber = false;
      this.numberShort = false;
    }
  }

  checkIfEmpty(value) {
    if (value == null || value === undefined) {
      this.noNumber = true;
      this.numberShort = false;
    }
  }

  rollbackOtp() {
    if (this.otpChallenge) {
      return;
    }
    this.remember = true;
    this.oldPhone = this.currentOnboarding.phone;
    this.currentOnboarding.phone = null;
  }

  restoreNumber() {
    this.remember = false;
    this.currentOnboarding.phone = this.oldPhone;
  }

  rollbackStepOtp() {
    if (this.otpChallenge) {
      return;
    }
    this.otpStep = 1;
    this.remember = true;
    this.oldPhone = this.currentOnboarding.phone;
    this.currentOnboarding.phone = 0;
    return this.onFocusCode(true);
  }

  sendNewOtpMessage() {
    if (this.otpChallenge) {
      return;
    }
    this.error_message_label = null;
    this.code_status_class = 'input-field';
    return this.sendMeOtpCode(true);
  }

  onFocusCode(reset) {
    if (this.otpChallenge) {
      return;
    }
    if (reset === true) {
      this.code_1 = null;
      this.code_2 = null;
      this.code_3 = null;
      this.code_4 = null;
    } else {
      switch (reset) {
        case 2:
          this.code_2 = null;
          break;
        case 3:
          this.code_3 = null;
          break;
        case 4:
          this.code_4 = null;
          break;
      }
    }
    this.new_sms_sent = false;
    this.code_status_class = 'input-field';
    this.error_message_label = null;
    return;
  }

  checkKeyOnMobilePhoneInput(e) {
    if ((e.which !== 8 && e.which !== 0 && e.which < 48) || e.which > 57) {
      e.preventDefault();
    }
    this.phoneNumberPre = false;
  }

  changeIt(e, index) {
    if (this.otpChallenge) {
      return;
    }

    if (e.key === 'Backspace') {
      switch (index) {
        case 3:
          document.getElementById('input-input_code_1').focus();
          break;
        case 4:
          document.getElementById('input-input_code_2').focus();
          break;
        case 5:
          document.getElementById('input-input_code_3').focus();
          break;
      }
    } else if (isNaN(e.key)) {
      switch (index - 1) {
        case 1:
          this.code_1 = null;
          return ((<HTMLInputElement>document.getElementById('input-input_code_1')).value = null);
        case 2:
          this.code_2 = null;
          return ((<HTMLInputElement>document.getElementById('input-input_code_2')).value = null);
        case 3:
          this.code_3 = null;
          return ((<HTMLInputElement>document.getElementById('input-input_code_3')).value = null);
        case 4:
          this.code_4 = null;
          return ((<HTMLInputElement>document.getElementById('input-input_code_4')).value = null);
      }
    } else {
      switch (index) {
        case 2:
          document.getElementById('input-input_code_2').focus();
          break;
        case 3:
          document.getElementById('input-input_code_3').focus();
          break;
        case 4:
          document.getElementById('input-input_code_4').focus();
          break;
      }
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control) => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  private scrollOnInvalidElement(invalidControl) {
    this.controlCheckbox();
    this.controlSecondCheckbox();
    this.controlButtonCheckbox();
    window.scroll({
      top: this.getTopOffset(invalidControl),
      left: 0,
      behavior: 'smooth',
    });

    fromEvent(window, 'scroll')
      .pipe(debounceTime(100), take(1))
      .subscribe(() => invalidControl.focus());
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  public firstConsent(e) {
    this.checkBox1 = !this.checkBox1;
    this.checkboxClass = !this.checkBox1;
    this.currentOnboarding.economicCondition = this.checkBox1;
    this.currentOnboarding.suppliesCondition = this.checkBox1;
    this.currentOnboarding.cadastralCondition = this.checkBox1;
    this.currentOnboarding.consentsCondition = this.checkBox1;
    this.allowFinish();
  }

  public secondConsent(e) {
    this.checkBox2 = !this.checkBox2;
    this.checkboxClass2 = !this.checkBox2;
    this.currentOnboarding.clauseCondition = this.checkBox2;
    this.allowFinish();
  }

  checkCodeValidity() {
    if (this.codeTemp.length === 4 || this.currentOnboarding.otp_four_digit.length === 4) {
      return (this.enableOtpVerificationButton = true);
    }
    if (this.currentOnboarding.otp_four_digit.length === undefined) {
      return null;
    }
  }

  changeStatus(value) {
    this.gtm.submitOnbEvent('clic su indietro', 'complete');
    this.statusBack.emit(value);
  }

  controlCheckbox() {
    if (!this.checkBox1) {
      return (this.checkboxClass = true);
    }
  }

  controlSecondCheckbox() {
    if (!this.checkBox2) {
      return (this.checkboxClass2 = true);
    }
  }

  controlButtonCheckbox() {
    this.checkboxClassButton = true;
  }

  checkLength(event, maxLength) {
    if (event.key === 'Backspace') {
      this.enableOtpVerificationButton = false;
      return true;
    }
    if (event.target.value.toString().length + 1 >= maxLength) {
      if (event.target.value.toString().length + 1 > maxLength) {
        event.target.value.split(0, -1);
        return false;
      }
      this.enableOtpVerificationButton = true;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/steps/alg-complete/alg-complete.component.ts